import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";

import AccountCircle from '@mui/icons-material/AccountCircle';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

import Dropdown, { MenuItem, MenuDivider } from './ui/Dropdown';
import ManagementPinModal from './ManagementPinModal';

import { PowerBiLoginRequest } from "../AuthConfig";
import useAppAccount from '../auth/useAppAccount';

const LoginMenu = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { isAuthenticated, displayName, logout } = useAppAccount();
  const [pinModalOpen, setPinModalOpen] = useState(false);

  const loginUser = () => {
    instance.loginRedirect(PowerBiLoginRequest);
  };

  const logoutUser = () => {
    navigate("/");
    logout();
  };

  if (isAuthenticated) {
    return (
      <div className="ml-auto mr-3">
        <Dropdown
          align="right"
          triggerClassName="flex items-center gap-1 px-2 py-1 text-sm font-medium uppercase text-white hover:bg-white/10 rounded"
          trigger={
            <>
              <AccountCircle fontSize="small" />
              <span className="normal-case">{displayName}</span>
              <KeyboardArrowDownIcon fontSize="small" />
            </>
          }
        >
          {(close) => (
            <>
              <MenuItem className="text-black text-sm" onClick={() => { close(); navigate("profile"); }}>
                <AccountCircle className="mr-2" fontSize="small" /> User Profile
              </MenuItem>
              <MenuDivider />
              <MenuItem className="text-black  text-sm" onClick={() => { close(); logoutUser(); }}>
                <LogoutIcon className="mr-2" fontSize="small" /> Logout
              </MenuItem>
            </>
          )}
        </Dropdown>
      </div>
    );
  }

  return (
    <div className="ml-auto mr-3 flex items-center gap-1">
      <button
        type="button"
        onClick={loginUser}
        className="flex items-center gap-1 rounded px-2 py-1 text-sm font-medium uppercase text-white hover:bg-white/10"
      >
        <LoginIcon fontSize="small" /> Login
      </button>
      <button
        type="button"
        onClick={() => setPinModalOpen(true)}
        className="flex items-center gap-1 rounded px-2 py-1 text-sm font-medium uppercase text-white hover:bg-white/10"
      >
        <VpnKeyIcon fontSize="small" /> Management Login
      </button>
      <ManagementPinModal
        open={pinModalOpen}
        onClose={() => setPinModalOpen(false)}
        onSuccess={() => { setPinModalOpen(false); navigate("/"); }}
      />
    </div>
  );
}

export default LoginMenu;
